<template>
    <CusDialog
        :title="title"
        v-dialogDrag
        :visible.sync="visibleSync"
        :modal="modal"
        :close-on-click-modal="false"
        width="80%"
        :destroy-on-close="true"
        :okVisible="false"
        :printVisible2="printVisible2"
        @print="print"
        v-if="visibleSync"
        modal-append-to-body="false"
    >
        <div v-loading="loading" :style="{ height: `${this.screenHeight - 200}px` }">
            <pdf v-for="i in numPages" :key="i" :src="src" :page="i"></pdf>
        </div>
    </CusDialog>
</template>

<script>
import { mapGetters } from 'vuex'
import pdf from '@/common/vue-pdf-4.1.0'
import printJs from 'print-js'
// 用于预览单份所见所得文书
var $vue = {
    name: `PdfFrame`,
    components: { pdf },
    props: {
        title: String,
        base64: String,
        printVisible2: false,
        visible: Boolean,
        modal: true
    },
    data() {
        return {
            numPages: 0,
            isShowSendPrintMessage: this.$root.isShowSendPrintMessage,
            loading: false
        }
    },
    mounted() {
    },
    computed: {
        ...mapGetters([`screenHeight`]),
        visibleSync: {
            get: function() {
                return this.visible
            },
            set: function(newval) {
                this.$emit(`update:visible`, newval)
            }
        },
        pdfdata() {
            return this.base64
        }
    },
    methods: {
        print() {
            let that = this
            console.log(`print`)
            printJs({ printable: this.base64,
                type: `pdf`,
                base64: true,
                onPrintDialogClose: () => {
                    if (that.isShowSendPrintMessage === `true`) {
                        setTimeout(function() {
                            that.$confirm(`提示`, {
                                title: `提示`,
                                message: `请确认打印是否已完成`,
                                confirmButtonText: `打印完成`,
                                cancelButtonText: `打印未完成`,
                                type: `warning`
                            }).then(() => {

                            }).catch(e => {
                                console.log(e)
                            })
                        }, 2000)
                    }
                } })
        }
    },
    watch: {
        pdfdata() {
            if (this.base64) {
                this.loading = true
                this.src = pdf.createLoadingTask(`data:application/pdf;base64,${this.base64}`)
                this.src.then(content => {
                    this.numPages = content.numPages
                    this.loading = false
                })
            }
        }
    }
}

export default $vue
</script>

<style scoped>
.docframe {
    border: none;
    background: #c0c4cc;
}
</style>



// WEBPACK FOOTER //
// src/common/PdfFrame.vue